<template>
  <section class="store-edit">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
      <Card :bordered="false" dis-hover>
        <p slot="title">基础信息</p>
        <Form-item label="门店名称" prop="storeName">
          <span>{{formValidate.storeName}}</span>
        </Form-item>
        <Form-item
          label="推荐人编码"
          prop="refereeCode"
          v-if="formValidate.refereeCode"
        >
          <span>{{ formValidate.refereeCode }}</span>
        </Form-item>
        <Form-item label="营业执照" prop="imgLecienceUrl">
          <upload-photo
            :readOnly="true"
            :handle-upload="handleUpload"
            photo-name="imgLecienceUrl"
            :default-photo="formValidate.imgLecienceUrl"
          ></upload-photo>
        </Form-item>
        <Form-item label="营业执照编码" prop="lecienceCode">
          <span>{{formValidate.lecienceCode}}</span>
        </Form-item>
        <Form-item label="营业执照名称" prop="lecienceName">
          <span>{{formValidate.lecienceName}}</span>
        </Form-item>
        <Form-item label="认证类型" prop="certificateType">
          <span>{{formValidate.certificateType==='00'?'三证合一':formValidate.certificateType==='01'?'三证':''}}</span>
        </Form-item>
        <div>
          <Form-item label="组织机构代码编码" prop="orginizeCode">
            <span>{{formValidate.orginizeCode}}</span>
          </Form-item>
          <Form-item label="税务登记证编码" prop="taxlienceType">
            <span>{{formValidate.taxlienceType}}</span>
          </Form-item>
        </div>
        <Form-item label="店内照片" prop="shopInImg">
          <upload-photo
            :readOnly="true"
            :handle-upload="handleUpload"
            photo-name="shopInImg"
            :default-photo="formValidate.shopInImg"
          ></upload-photo>
        </Form-item>
        <Form-item label="门牌号照片" prop="shopNumImg">
          <upload-photo
            :readOnly="true"
            :handle-upload="handleUpload"
            photo-name="shopNumImg"
            :default-photo="formValidate.shopNumImg"
          ></upload-photo>
        </Form-item>
        <Form-item label="业务员手机号" prop="businessMobile">
          <span>{{formValidate.businessMobile}}</span>
        </Form-item>
        <Form-item label="联系人" prop="contactPerson">
          <span>{{formValidate.contactPerson}}</span>
        </Form-item>
        <Form-item label="联系人手机号" prop="contactMobile">
          <span>{{formValidate.contactMobile}}</span>
        </Form-item>
        <Form-item label="所属地区" prop="storeArea" style="position: relative">
          <span>{{formValidate.storeAreaName}}</span>
        </Form-item>
        <Form-item label="详细地址" prop="storeAddress">
          <span>{{formValidate.storeAddress}}</span>
          <amap-controls style="margin-top: 20px"></amap-controls>
        </Form-item>
        <Form-item label="平台资金商" prop="dealerCode">
          <span>{{ getDealerName() }}</span>
        </Form-item>
        <Form-item label="渠道编码" prop="channelCode">
          <Select
            v-model="formValidate.channelCode"
            disabled
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in channelInfoqQueryList"
              >{{ item.label }}
            </Option>
          </Select>
        </Form-item>
        <Form-item label="平台编码" prop="platformCode">
          <Select
            disabled
            v-model="formValidate.platformCode"
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in platformCodeList"
              >{{ item.label }}
            </Option>
          </Select>
        </Form-item>
        <Form-item label="平台服务商" prop="serviceCode">
          {{ getServiceName() }}
        </Form-item>
        <Form-item label="erp代码" prop="erpCode">
          <span>{{ formValidate.erpCode }}</span>
        </Form-item>
        <Form-item label="mdm代码" prop="mdmCode">
          <span>{{ formValidate.mdmCode }}</span>
        </Form-item>
        <Form-item label="planAccount" prop="planAccount">
          <span>{{ formValidate.planAccount }}</span>
        </Form-item>
        <Form-item label="是否可以下单" prop="canOrder">
          <span>{{formValidate.canOrder === '0' ? '不能下单' : formValidate.canOrder === '1' ? '不能下单' : ''}}</span>
        </Form-item>
        <Form-item label="门店状态" prop="status">
          <Select
            disabled
            v-model="formValidate.status"
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in statusList"
              >{{ item.label }}
            </Option>
          </Select>
        </Form-item>
      </Card>
      <Card :bordered="false" dis-hover>
        <p slot="title">开票信息</p>
        <Form-item label="发票类型" prop="invoiceType">
          <span>{{formValidate.invoiceType=='1'?'增值税专用发票':formValidate.invoiceType=='2'?'增值税普通发票':''}}</span>
        </Form-item>
        <Form-item label="开户账号" prop="bankAccount">
          <span>{{ formValidate.bankAccount }}</span>
        </Form-item>
        <Form-item label="开户银行" prop="bankName">
          <span>{{ formValidate.bankName }}</span>
        </Form-item>
        <Form-item label="单位地址" prop="companyAddress">
          <span>{{ formValidate.companyAddress }}</span>
        </Form-item>
        <Form-item label="开票公司" prop="invoiceCompany">
          <span>{{ formValidate.invoiceCompany }}</span>
        </Form-item>
        <Form-item label="联系电话" prop="invoiceMobile">
          <span>{{ formValidate.invoiceMobile }}</span>
        </Form-item>
        <Form-item label="税号" prop="invoiceNumber">
          <span>{{ formValidate.invoiceNumber }}</span>
        </Form-item>
        <Form-item label="发票主体营业执照" prop="invoiceImgLecienceUrl">
          <upload-photo
            :readOnly="true"
            :handle-upload="handleUpload"
            photo-name="invoiceImgLecienceUrl"
            :default-photo="formValidate.invoiceImgLecienceUrl"
          ></upload-photo>
        </Form-item>
        <Form-item label="发票收件人姓名" prop="invoiceReceiveName">
          <span>{{ formValidate.invoiceReceiveName }}</span>
        </Form-item>
        <Form-item label="发票收件人手机号" prop="invoiceReceivePhone">
          <span>{{ formValidate.invoiceReceivePhone }}</span>
        </Form-item>
        <Form-item label="发票收件人地址" prop="invoiceReceiveAddr">
          <span>{{ formValidate.invoiceReceiveAddr }}</span>
        </Form-item>
        <Form-item label="专票授权文件" prop="specialInvoiceAuthDocUrl">
          <upload-photo
            :readOnly="true"
            :handle-upload="handleUpload"
            photo-name="specialInvoiceAuthDocUrl"
            :default-photo="formValidate.specialInvoiceAuthDocUrl"
          ></upload-photo>
        </Form-item>
      </Card>
      <Card :bordered="false" dis-hover>
        <p slot="title">经营信息</p>
        <Form-item label="门店类型" prop="retType">
          <span>{{ getRetType() }}</span>
        </Form-item>
        <Form-item label="食品经营许可证号" prop="fblCode">
          <span>{{ formValidate.fblCode }}</span>
        </Form-item>
        <Form-item label="食品许可证" prop="fblImgUrl">
          <upload-photo
            :readOnly="true"
            :handle-upload="handleUpload"
            photo-name="fblImgUrl"
            :default-photo="formValidate.fblImgUrl"
          ></upload-photo>
        </Form-item>
      </Card>
      <Card :bordered="false" dis-hover>
        <p slot="title">收货信息</p>
        <Form-item label="联系人" prop="receivePerson">
          <span>{{ formValidate.receivePerson }}</span>
        </Form-item>
        <Form-item label="联系人手机号" prop="receiveMobile">
          <span>{{ formValidate.receiveMobile }}</span>
        </Form-item>
        <Form-item label="所属地区" prop="atpids">
          <span>{{ formValidate.atnames }}</span>
        </Form-item>
        <Form-item label="详细地址" prop="receiveAddr">
           <span>{{ formValidate.receiveAddr }}</span>
        </Form-item>
      </Card>
      <FormItem class="br mfooter">
        <Button @click="handleReset">返回</Button>
        <!-- <Button @click="handleSave" type="primary" style="margin-left: 10px"
          >保存</Button
        > -->
      </FormItem>
    </Form>
  </section>
</template>

<script>
import { initFormValidate, ruleValidate } from "./validate/rule";
import uploadPhoto from "@/views/store/components/uploadPhoto";
import amapControls from "@/views/store/components/amapControls";

export default {
  name: "store-edit",
  components: {
    uploadPhoto,
    amapControls,
  },
  data() {
    const { retCode } = this.$route.query;
    return {
      formValidate: initFormValidate,
      ruleValidate: ruleValidate,
      retCode: retCode,
      addressData: [],
      // addressArray: [],
      userTypeQueryAllList: [],
      spInfoQueryAllList: [],
      channelInfoqQueryList: [
        { label: "GT", value: "GT" },
        { label: "KA", value: "KA" },
        { label: "OTHERS", value: "OTHERS" },
      ],
      retailerTypeQueryList: [
        { label: "直接订货门店", value: "0" },
        { label: "总仓配货门店", value: "1" },
        { label: "总仓和门店", value: "2" },
        { label: "总仓", value: "3" },
        { label: "联盟总店", value: "21" },
        { label: "联盟分店", value: "22" },
      ],
      platformCodeList: [
        { label: "易购APP", value: "0001" },
        { label: "微信小程序门店版", value: "0002" },
        { label: "易掌柜", value: "0003" },
        { label: "业务管理后台", value: "0004" },
      ],
      statusList: [
        { label: "正常", value: "0" },
        { label: "停用", value: "1" },
        { label: "审核失败", value: "2" },
        { label: "冻结", value: "3" },
        { label: "关店", value: "4" },
        { label: "待审核", value: "5" },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getShopInfo();
      this.getUserTypeQueryAll();
      this.getSpInfoQueryAll();
    },
    // 资金商列表
    getSpInfoQueryAll() {
      this.$api["spInfoQueryAll"]().then(({ data }) => {
        this.spInfoQueryAllList = data;
      });
    },
    getUserTypeQueryAll() {
      this.$api["userTypeQueryAll"]().then(({ data }) => {
        this.userTypeQueryAllList = data;
      });
    },
    getShopInfo() {
      this.getBaseAreaQueryAll().then((res) => {
        this.addressData = res;
      });
      if (!this.retCode) return false;
      const params = {
        code: this.retCode,
      };
      this.$api["shopInfoQuery"](params).then(async ({ data }) => {
        let storeArea = data.storeArea
          ? data.storeArea.split("-").map((d, i, o) => {
              return o.slice(0, i + 1).join("-");
            })
          : [];
        storeArea.length && storeArea.shift();
        let atpids =
          data.shippingAddr && data.shippingAddr.atpids
            ? data.shippingAddr.atpids.split("-").map((d, i, o) => {
                return o.slice(0, i + 1).join("-");
              })
            : [];
        atpids.length && atpids.shift();
        //处理地理位置
        // const addressData = await this.getBaseAreaQueryAll();
        // this.addressData = addressData;
        const len = storeArea.length;
        let storeAreaName = "";
        const storeAreaData = await this.getBaseAreaQueryAll(
          storeArea[len - 2].split("-").pop()
        );
        storeAreaData.forEach((d) => {
          if (d.value === storeArea[len - 1]) {
            storeAreaName = d.label;
            this.changeArea(d.label);
          }
        });
        this.formValidate = Object.assign(data, {
          storeName: data.retName,
          storeAddress: data.addr,
          receivePerson: data.shippingAddr.receivePerson,
          receiveMobile: data.shippingAddr.receiveMobile,
          receiveAddr: data.shippingAddr.addr,
          atnames: data.shippingAddr.atnames,
          storeArea: storeArea,
          atpids: atpids,
          storeAreaName,
        });
        if (Array.isArray(data.retailerPhotos)) {
          data.retailerPhotos.map((item) => {
            switch (item.imgName) {
              case "店内照片":
                this.formValidate.shopInImg = item.imgUrl;
                break;
              case "门牌号照片":
                this.formValidate.shopNumImg = item.imgUrl;
                break;
              case "食品许可证照片":
                this.formValidate.fblImgUrl = item.imgUrl;
                break;
              default:
                break;
            }
          });
        }
      });
    },
    changeArea(label) {
      if (typeof label === "string") {
        this.$bus.$emit(
          "searchAddress",
          label + this.formValidate.storeAddress
        );
      } else {
        this.$bus.$emit(
          "searchAddress",
          this.formValidate.storeAreaName + this.formValidate.storeAddress
        );
      }
    },
    async loadData(item, callback) {
      if (item.loading != null) item.loading = true;
      const addressData = await this.getBaseAreaQueryAll(
        item.value.split("-").pop()
      );
      if (addressData.length) {
        item.children = addressData;
      }
      if (item.loading != null) item.loading = false;
      callback();
    },
    async getBaseAreaQueryAll(code = "") {
      const params = {
        code,
      };
      const { data } = await this.$api["queryForShop"](params);
      const addressData = this.convertAddressTree(data);
      return addressData;
    },
    handleUpload(v, name) {
      this.formValidate[name] = v;
    },
    handleReset() {
      this.formValidate = initFormValidate;
      this.$refs["formValidate"].resetFields();
      this.$router.back(-1);
    },
    async handleSave() {
      this.$refs["formValidate"].validate(async (valid) => {
        if (valid) {
          let params = Object.assign({}, this.formValidate, {
            atpids: this.formValidate.atpids.pop(),
            storeArea: this.formValidate.storeArea.pop(),
          });
          delete params.retailerPhotos;
          delete params.retailerUser;
          delete params.shippingAddr;
          const { data, code } = this.retCode
            ? await this.$api["shopInfoUpdate"](params)
            : await this.$api["shopInfoAdd"](params);
          if (code == "200") {
            this.$Message.success(`${this.retCode ? "更新" : "新增"}门店成功`);
            this.$router.back(-1);
          }
        }
      });
    },
    convertAddressTree(tree) {
      tree.forEach((item) => {
        if (item.children != 0) {
          item.children = [];
          item.loading = false;
        } else {
          delete item.children;
        }
      });
      return tree;
    },

    getRetType() {
      const res = this.retailerTypeQueryList.filter(
        (d) => d.value == this.formValidate.retType
      );
      if (res.length) {
        return res[0].label;
      }
    },

    getUserType() {
      const res = this.userTypeQueryAllList.filter(
        (d) => d.id == this.formValidate.userType
      );
      if (res.length) {
        return res[0].typeName;
      }
    },

    getServiceName() {
      const res = this.spInfoQueryAllList.filter(
        (d) => d.code == this.formValidate.serviceCode && d.stype == "1"
      );
      if (res.length) {
        return res[0].name;
      }
    },

    getDealerName() {
      const res = this.spInfoQueryAllList.filter(
        (d) => d.code == this.formValidate.dealerCode && d.stype == "0"
      );
      if (res.length) {
        return res[0].name;
      }
    },

    changeStoreArea(value, selectedData) {
      console.log(value);
      const len = selectedData.length;
      this.formValidate.storeArea = value;
      this.formValidate.storeAreaName = selectedData[len - 1].label;
    },
    changeAtpids(value, selectedData) {
      const len = selectedData.length;
      this.formValidate.atpids = value;
      this.formValidate.atnames = selectedData[len - 1].label;
    },
  },
};
</script>

<style scoped>
.store-edit .ivu-form-item {
  margin-bottom: 20px;
}
.mfooter {
  position: fixed;
  right: 25px;
  bottom: -20px;
  z-index: 1000;
  padding: 10px 0;
  width: 80%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeDetail.vue